import { FC, RefObject } from 'react';

import headerButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/header/header_button_click';
import { ActivatorElementType } from '@hh.ru/magritte-internal-drop-base';
import { Divider, Drop } from '@hh.ru/magritte-ui';

import { BalanceCardBottom } from 'components/common/BalanceCardContent/BalanceCardBottom/BalanceCardBottom';
import { BalanceCardTop } from 'components/common/BalanceCardContent/BalanceCardTop/BalanceCardTop';

import styles from 'components/Header/HeaderBalanceDrop/HeaderBalanceDrop.module.less';

interface HeaderBalanceDropProps {
    dropActivatorRef: RefObject<ActivatorElementType>;
    isDropVisible: boolean;
    setIsDropVisibleOff: () => void;
    setIsBalanceReplenishmentModalVisibleOn: () => void;
}

export const HeaderBalanceDrop: FC<HeaderBalanceDropProps> = ({
    dropActivatorRef,
    isDropVisible,
    setIsDropVisibleOff,
    setIsBalanceReplenishmentModalVisibleOn,
}) => {
    const onTopUpButtonClick = () => {
        setIsBalanceReplenishmentModalVisibleOn();
        setIsDropVisibleOff();
        headerButtonClick({ buttonName: 'invoice_create_header' });
    };

    return (
        <Drop
            style={{ marginTop: 24 }}
            width={444}
            visible={isDropVisible}
            activatorRef={dropActivatorRef}
            placement="bottom-right"
            forcePlacement
            onClose={setIsDropVisibleOff}
            padding={0}
        >
            <div className={styles.dropTopWrapper}>
                <BalanceCardTop onTopUpButtonClick={onTopUpButtonClick} />
            </div>
            <Divider />
            <div className={styles.dropTopWrapper}>
                <BalanceCardBottom />
            </div>
        </Drop>
    );
};
